import { Col } from "react-bootstrap";
import { BoxArrowUpRight } from "react-bootstrap-icons";
import { Tags } from "./Tags";

export const FeaturedProjectCard = ({ title, badge, imgUrl, imgFit, summary, details, tags, links }) => {
  return (
    <Col xs={12} md={6}>
      <article className="featured-card">
        <div className={`featured-media ${imgFit === "contain" ? "contain" : ""}`}>
          {imgUrl
            ? <img src={imgUrl} alt={title} loading="lazy" />
            : <span className="featured-placeholder">{title}</span>}
        </div>
        <div className="featured-body">
          <span className="badge-label">{badge}</span>
          <h3>{title}</h3>
          <p className="summary">{summary}</p>
          <p className="details">{details}</p>
          <Tags items={tags} />
          {links.length > 0 &&
            <div className="featured-links">
              {links.map((link) => (
                <a key={link.url} href={link.url} target="_blank" rel="noopener noreferrer">
                  {link.label} <BoxArrowUpRight size={14} />
                </a>
              ))}
            </div>}
        </div>
      </article>
    </Col>
  )
}
